import Vue from "vue";

import VueScrinz from "@/modules/sz";
Vue.use(VueScrinz);

import { ScrinzVuePlugin } from "@scrinz/vue";
Vue.use(ScrinzVuePlugin);
